import * as RadixAccordion from "@radix-ui/react-accordion";

export function Content({ children }: { children: React.ReactNode }) {
  return (
    <RadixAccordion.Content className="px-5 pb-5">
      {children}
    </RadixAccordion.Content>
  );
}
